<div class="container">
	<div class="search">
		<ic-autocomplete
			[class.error]="error"
			[disableClickHandler]="disableClickHandler"
			[formControl]="autoCompleteControl"
			[icon]="icon"
			[iconRight]="iconRight"
			[items]="items"
			[label]="label"
			[loading]="loading"
			[placeholder]="placeholder"
			[threshold]="0"
			(optionSelected)="itemAdded($event)"
			(valueChange)="inputChanged($event)"
		>
			<ng-template #itemTmpl let-disabled="disabled" let-item>
				@if (itemTemplate) {
					<ng-template
						[ngTemplateOutlet]="itemTemplate"
						[ngTemplateOutletContext]="{ $implicit: item, disabled: disabled }"
					/>
				} @else {
					{{ item }}
				}
			</ng-template>

			<ng-template #loadingTmpl>
				<p class="loading"><i class="fa fa-spinner fa-spin"></i> {{ "general.loading" | translate | lowercase }}</p>
			</ng-template>

			<ng-template #emptyTmpl> {{ "general.noData" | translate }} </ng-template>
		</ic-autocomplete>
	</div>

	@if (error && errorTmpl) {
		<ng-container *ngTemplateOutlet="errorTmpl" />
	}

	<div class="chosen" data-test="chosen-items">
		@for (option of selectedItems; track option; let i = $index) {
			<div class="space">
				<ic-badge-text
					class="badge"
					data-test="badge"
					[type]="error ? 'danger' : 'secondary'"
					(closeItem)="itemRemoved(i)"
				>
					@if (selectedTemplate) {
						<ng-template [ngTemplateOutlet]="selectedTemplate" [ngTemplateOutletContext]="{ $implicit: option }" />
					} @else {
						@if (itemTemplate) {
							<ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: option }" />
						} @else {
							{{ option }}
						}
					}
				</ic-badge-text>
			</div>
		}
	</div>
</div>
